exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrap[data-v-47fb9e3a] {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n  padding: 1rem;\n}\n.left[data-v-47fb9e3a],\n.right[data-v-47fb9e3a] {\n  -webkit-box-flex: 1;\n          flex: 1;\n}\n", ""]);

// exports
